// WebView 83 lacks String.replaceAll (Chrome 85 API); string-pattern
// version covers all repo callers. Remove when fleet WebView >= 85.
if (!String.prototype.replaceAll) {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = function (s, r) {
    return this.split(s).join(r);
  };
}

import React from "react";
import "./dayjs-setup";
import { createRoot } from "react-dom/client";
import storeObj from "./redux/store";
import { Provider } from "react-redux";
import { SnackbarProvider } from "notistack";
import { PersistGate } from "redux-persist/integration/react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import App from "./App";
import { domainLevelConfig } from "./ui-config";

const host = window.location.host;
const hostConfig =
  domainLevelConfig[host] || domainLevelConfig["default"] || {};

// ponytail: MUI Modal sets aria-hidden on #root; Chrome warns if focus stays inside.
// Swap aria-hidden→inert (native focus block + a11y compliant).
const rootEl = document.getElementById("root");
new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.attributeName !== "aria-hidden") continue;
    if (m.target.getAttribute("aria-hidden") === "true") {
      m.target.removeAttribute("aria-hidden");
      m.target.setAttribute("inert", "");
    } else if (!m.target.hasAttribute("aria-hidden")) {
      m.target.removeAttribute("inert");
    }
  }
}).observe(rootEl, { attributes: true, subtree: true });

const root = createRoot(rootEl);
root.render(
  <HelmetProvider>
    <Helmet>
      <meta name="description" content={hostConfig.description} />
      <meta name="author" content={hostConfig.name} />
      <meta property="og:site_name" content={hostConfig.name} />
      <meta property="og:site" content={hostConfig.url} />
      <meta property="og:title" content={hostConfig.title} />
      <meta property="og:description" content={hostConfig.description} />
      <meta property="og:image" id="seo-image" content={hostConfig.seoImage} />
      <meta property="og:url" content={hostConfig.url} />
    </Helmet>
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      autoHideDuration={1500}
    >
      <Provider store={storeObj().store}>
        <PersistGate loading={null} persistor={storeObj().persistor}>
          <App />
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  </HelmetProvider>
);
